import { createSlice } from '@reduxjs/toolkit';
import { IUserPreferences } from 'packages/lib-utils';

export interface UserPreferencesState {
  preferences: IUserPreferences[];
  error: boolean;
  persistedPreferences: { [key: string]: any };
}
const initialState: UserPreferencesState = {
  preferences: [],
  error: false,
  persistedPreferences: {},
};
export const UserPreferencesSlice = createSlice({
  name: 'UserPreferences',
  initialState,
  reducers: {
    setPreferences: (state, action) => {
      state.preferences = action.payload;
      state.error = false;
    },
    setPreferencesError: (state) => {
      state.error = true;
      state.preferences = [];
    },
    resetPreferences: (state) => {
      state.preferences = initialState.preferences;
      state.error = initialState.error;
    },
    setPersistedPreferences: (state, action) => {
      state.persistedPreferences = {
        ...state.persistedPreferences,
        ...action.payload,
      };
    },
  },
});

export const { setPreferences, resetPreferences, setPreferencesError, setPersistedPreferences } =
  UserPreferencesSlice.actions;
export default UserPreferencesSlice.reducer;
